var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 84,
    viewBox: "0 0 71 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_584_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.654 13.3442L6.94583 24.9878L9.58678 30.8366L15.4734 30.5174L19.654 13.3442Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2103 35.675L19.654 13.3442L15.4734 30.5174L25.2103 35.675Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2236 47.3711L9.58678 30.8363L15.4734 30.5171L18.2236 47.3711Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2103 35.6747L18.2236 47.3711L15.4734 30.5171L25.2103 35.6747Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44145 33.9204L2.20278 42.3912L7.77648 48.93L11.1587 42.714L4.44145 33.9204Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6842 53.4875L11.1587 42.7139L7.77648 48.9299L15.636 56.2955L18.6842 53.4875Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1118 58.7366L15.636 56.2958L7.77648 48.9302L6.10897 54.1778L13.1118 58.7366Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.296875 50.2187L2.20278 42.3911L7.77648 48.9299L6.10897 54.1775L0.296875 50.2187Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3879 0V19.0608L23.5043 19.8576L24.4405 10.554L35.3879 0Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3879 19.061V31.6082L29.8863 34.799L23.5043 19.8578L35.3879 19.061Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3879 37.6826V51.6974L23.5651 50.8058V44.3018L35.3879 37.6826Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3879 64.1665V51.6973L23.5651 50.8057V57.5473L35.3879 64.1665Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5639 57.5171V71.5307L11.7423 70.6391V64.1351L23.5639 57.5171Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5639 84V71.5308L11.7423 70.6392V77.382L23.5639 84Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5651 57.5171V71.5307L35.3879 70.6391V64.1351L23.5651 57.5171Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5651 84V71.5308L35.3879 70.6392V77.382L23.5651 84Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0363 13.3442L63.7431 24.9878L61.1034 30.8366L55.2168 30.5174L51.0363 13.3442Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4799 35.675L51.0363 13.3442L55.2168 30.5174L45.4799 35.675Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4654 47.3711L61.1034 30.8363L55.2168 30.5171L52.4654 47.3711Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4799 35.6747L52.4654 47.3711L55.2168 30.5171L45.4799 35.6747Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2488 33.9204L68.4874 42.3912L62.9137 48.93L59.5315 42.714L66.2488 33.9204Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0047 53.4875L59.5315 42.7139L62.9137 48.9299L55.0529 56.2955L52.0047 53.4875Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5784 58.7366L55.0529 56.2958L62.9137 48.9302L64.5812 54.1778L57.5784 58.7366Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3921 50.2187L68.4874 42.3911L62.9137 48.9299L64.5812 54.1775L70.3921 50.2187Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3023 0V19.0608L47.1847 19.8576L46.2498 10.554L35.3023 0Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3023 19.061V31.6082L40.8039 34.799L47.1847 19.8578L35.3023 19.061Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3023 37.6826V51.6974L47.1239 50.8058V44.3018L35.3023 37.6826Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3023 64.1665V51.6973L47.1239 50.8057V57.5473L35.3023 64.1665Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1251 57.5171V71.5307L58.9467 70.6391V64.1351L47.1251 57.5171Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1251 84V71.5308L58.9467 70.6392V77.382L47.1251 84Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1239 57.5171V71.5307L35.3023 70.6391V64.1351L47.1239 57.5171Z",
    fill: "#E09A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1239 84V71.5308L35.3023 70.6392V77.382L47.1239 84Z",
    fill: "#E09A3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_584_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.0952,
    height: 84,
    fill: "white",
    transform: "translate(0.296875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.593ea71b9d1ebdd973a790ef1a51f956.svg";
export { ForwardRef as ReactComponent };